import callAPiBase from './base';

const linesMatrixIntegrationApi = {
  list: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/lineMatrixIntegrationList',
      method: 'GET',
      useToken: true,
      title: 'Lines Matrix Integration - Get List',
      params,
    }),
  get: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/lineMatrixIntegrationList',
      method: 'GET',
      useToken: true,
      title: 'Lines Matrix Integration - Get',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lineMatrixIntegrationCreate',
      method: 'POST',
      useToken: true,
      title: 'Line Matrix Integration - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/lineMatrixIntegrationUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Line Matrix Integration - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/lineMatrixIntegrationDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Line Matrix Integration - Delete',
      params,
    }),
};

export { linesMatrixIntegrationApi };
export default linesMatrixIntegrationApi;
